import * as React from 'react'

/**
 * @description Building icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Building } from '@sravni/design-system-icons'
 *
 * <Building />
 * ```
 */
export const Building = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Building" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="2.486" y="10.75" width="16.5" height="7.5" rx="2.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M6.736 13.798v1.404M10.736 13.798v1.404M14.736 13.798v1.404"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="m5.236 10 5.5-3.8 5.5 3.8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.77.93a.75.75 0 0 0-1.5 0h1.5Zm-.75 2.593h-.75a.75.75 0 0 0 .487.702l.264-.702ZM9.487 5.426a.75.75 0 0 0-1.5 0h1.5Zm.785-4.495v2.592h1.5V.93h-1.5Zm.486 3.294c.525.197.883.35 1.121.545.187.152.296.325.296.656h1.5c0-.81-.335-1.399-.846-1.817-.46-.377-1.054-.605-1.544-.788l-.527 1.404Zm1.417 1.201a.77.77 0 0 1-.342.67c-.238.172-.597.28-.998.278-.4-.002-.763-.114-1.004-.288a.765.765 0 0 1-.344-.66h-1.5c0 .828.4 1.468.965 1.876.545.393 1.23.57 1.876.572.646.003 1.333-.166 1.88-.56.571-.41.967-1.054.967-1.888h-1.5Z"
      fill="currentColor"
    />
  </svg>
))
